/*
 * File: d:\projects\AutoFiFront\src\Utils\Context.ts
 * Project: d:\projects\AutoFiFront
 * Created Date: Tuesday March 28th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Tuesday March 28th 2023 3:02:29 pm
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 * HISTORY:
 */

import { createContext, useContext } from "react";

class myContext {
  language = "fr";
  setLanguage = (lang: string) => {
    this.language = lang;
  };
  idsCart: React.MutableRefObject<number[]> | null = null;
}

const Context = createContext(new myContext());
const useMyContext = () => useContext(Context);

export { Context, useMyContext };
